/**
 * Configuration for pages that display sensitive financial data
 * 
 * Pages listed here will show the sensitive data toggle in the header.
 * Add new pages to this list when they contain financial information that
 * should be maskable (revenue, costs, margins, budgets, etc.)
 */
export const PAGES_WITH_SENSITIVE_DATA = [
  'dashboard',        // Homepage - Shows revenue, costs, and financial KPIs
  'projects',         // Displays budget revenue, actual revenue, costs, margins
  'project-details',  // Extensive financial data (budgets, actuals, variance, margins, WIP, unbilled)
  'portfolio',        // Shows financial metrics across portfolios
  'wip-reporting',    // Work in Progress - Contains WIP amounts, unbilled amounts, and financial data
  'project-transactions', // Transaction reporting - Shows sales, costs, and financial values
  'project-status-report', // Project Status Report - Contains contract values, GP%, actual costs and revenue
  'budget-variance',       // Budget Variance Report - Contains budget, actuals, variance and revenue data
  'project-pl',            // Project P&L Report - Contains revenue, costs, GP%, margins, and variance data
  'project-forecast',      // Project Forecast Report - Contains EAC, budget, variance and revenue forecast data
  'profitability',         // Profitability Analysis Report — portfolio GP, margin, and P&L breakdown
  'profitability-report',  // Profitability Analysis Report — portfolio GP, margin, and P&L breakdown
] as const;

/**
 * Check if a page should display the sensitive data toggle
 */
export function shouldShowSensitiveDataToggle(currentPage: string): boolean {
  return PAGES_WITH_SENSITIVE_DATA.includes(currentPage as any);
}
